if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
        // Update gallery indicator when slide changes
        this.updateGalleryIndicator();
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        
        // Update gallery indicator when media changes
        this.updateGalleryIndicator();
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      // Add the updateGalleryIndicator method
      updateGalleryIndicator() {
        const activeSlide = this.elements.viewer.querySelector('.product__media-item.is-active');
        const allSlides = this.elements.viewer.querySelectorAll('.product__media-item');
        const indicator = document.querySelector('.gallery-image-indicator__current');
        
        if (activeSlide && allSlides.length > 0 && indicator) {
          const currentIndex = Array.from(allSlides).indexOf(activeSlide) + 1;
          indicator.textContent = currentIndex;
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

// Gallery navigation functionality
document.addEventListener('DOMContentLoaded', function() {
  const galleryNavButtons = document.querySelectorAll('[data-gallery-nav]');
  
  galleryNavButtons.forEach(button => {
    button.addEventListener('click', function() {
      const direction = this.getAttribute('data-gallery-nav');
      const mediaGallery = this.closest('media-gallery');
      const slider = mediaGallery.querySelector('.product__media-list');
      const slides = slider.querySelectorAll('.product__media-item');
      const currentSlide = slider.querySelector('.product__media-item.is-active');
      
      if (!currentSlide || slides.length <= 1) return;
      
      let currentIndex = Array.from(slides).indexOf(currentSlide);
      let nextIndex;
      
      if (direction === 'next') {
        nextIndex = currentIndex + 1 >= slides.length ? 0 : currentIndex + 1;
      } else {
        nextIndex = currentIndex - 1 < 0 ? slides.length - 1 : currentIndex - 1;
      }
      
      // Remove active class from current slide
      currentSlide.classList.remove('is-active');
      
      // Add active class to next slide
      slides[nextIndex].classList.add('is-active');
      
      // Update thumbnails if they exist
      const thumbnails = mediaGallery.querySelectorAll('.thumbnail-list__item button');
      if (thumbnails.length > 0) {
        thumbnails.forEach(thumb => thumb.removeAttribute('aria-current'));
        if (thumbnails[nextIndex]) {
          thumbnails[nextIndex].setAttribute('aria-current', 'true');
        }
      }
      
      // Scroll to the active slide
      slides[nextIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
      
      // Update slider counter if it exists
      const counter = mediaGallery.querySelector('.slider-counter--current');
      if (counter) {
        counter.textContent = nextIndex + 1;
      }
      
      // Update gallery image indicator
      const indicator = document.querySelector('.gallery-image-indicator__current');
      if (indicator) {
        indicator.textContent = nextIndex + 1;
      }
    });
  });
  
  // Initialize gallery indicator on page load
  const mediaGallery = document.querySelector('media-gallery');
  if (mediaGallery) {
    const galleryInstance = mediaGallery;
    if (galleryInstance.updateGalleryIndicator) {
      galleryInstance.updateGalleryIndicator();
    }
  }
});
